export default __webpack_public_path__ + "static/media/icon-02.01d99a9f.svg";